import { ReactNode, useLayoutEffect, useRef, useState } from 'react';
import { MEDIA_QUERIES, SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import { Z_INDICES } from 'verify/styles/variables';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;

  position: absolute;
  z-index: ${Z_INDICES.footer};
  left: 0;
  right: 0;
  bottom: 0;

  @media ${MEDIA_QUERIES.isMobile} {
    position: fixed;
  }

  padding-top: ${SPACINGS.base}px;
  padding-bottom: ${SPACINGS.widgetPadding};
  /* IE11 fallbacks */
  padding-left: ${SPACINGS.widgetPadding};
  padding-right: ${SPACINGS.widgetPadding};
  /* For Apple devices with notches; will be ignored for other devices */
  /* This allows us to use object-fit=cover in the HTML's meta tag */
  /* https://webkit.org/blog/7929/designing-websites-for-iphone-x/ */
  padding-left: calc(${SPACINGS.widgetPadding} + env(safe-area-inset-left));
  padding-right: calc(${SPACINGS.widgetPadding} + env(safe-area-inset-right));
`;

interface FooterProps {
  children: ReactNode;
  className?: string;
}

/**
 * A generic sticky footer component. Distinct from the UI component.
 * @see inquiry/components/Footer/Footer.tsx
 */
export default ({ children, className }: FooterProps) => {
  const [spacerHeight, setSpacerHeight] = useState(SPACINGS.base * 7);
  const containerRef = useRef<HTMLDivElement>();
  useLayoutEffect(() => {
    const footerHeight =
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      containerRef.current?.getBoundingClientRect().height - parseInt(SPACINGS.widgetPadding);
    if (footerHeight >= 0) {
      setSpacerHeight(Math.floor(footerHeight));
    }
  });
  // div allows fixed position while still taking space.
  // Note that we cannot use position: sticky because of IE11.
  return (
    <>
      <div aria-hidden style={{ height: spacerHeight }} />
      {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
      <Container data-test='footer' ref={containerRef} className={className}>
        {children}
      </Container>
    </>
  );
};
